import * as React from 'react';
import EmailPreview from './email_preview';
import { shallow, ShallowWrapper } from 'enzyme';

let wrapped: ShallowWrapper;

describe('Email Preview component', () => {
  beforeEach(() => {
    wrapped = shallow(<EmailPreview hide='' form='' title='' url='' />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
